export const trimBreadcrumbs = (text?: string) => {
  if (!text) return text
  if (text.length > 60) return `${text.substring(0, 58)}…`
  return text
}
